import { useSideMenu } from '@/components/NewHeader/SideMenu/useSideMenu';
import { useHeaderScroll } from '@/components/NewHeader/useHeaderScroll';
import { cn } from '@/lib/utils';
import Link from 'next/link';

export function CtaLink({
  href,
  children,
  className,
  onClick,
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  const { close: closeNav } = useHeaderScroll();
  const { close: closeSideMenu } = useSideMenu();

  return (
    <Link
      className={cn(
        'group flex justify-center items-center cursor-pointer leading-4 tracking-[2px] transition ease-in-out duration-200 outline-none',
        'bg-primary text-white hover:bg-white hover:text-graphite border-2 border-primary text-center',
        'w-full uppercase text-sm font-bold py-5 px-8',
        className,
      )}
      href={href}
      onClick={() => {
        if (onClick) {
          onClick();
        }
        closeNav();
        closeSideMenu();
      }}>
      {children}
    </Link>
  );
}
